import { useEffect, useRef } from "react"

import { useTracker } from "src/hooks/use_tracker"

import {
  NEW_LAUNCH_STARTED_EVENT,
  SURFACE_PROPERTY,
  addonOptionsShown,
} from "./launchAddOnTracking"

// Matches iOS (MOB-1027): new_launch_started fires once per opening of the
// form, when the first add-on catalog request settles, and carries
// addon_options_shown — the denominator for the launch add-on rate.
//
// A failed catalog still fires, with a null count: zero says the marina offered
// nothing, and a failure must not be read as that. Switching reservation does
// not fire again. Both modals stay mounted and toggle `isOpen`, so closing the
// form is what re-arms it.
export const useNewLaunchStarted = ({
  surface,
  open,
  trackingProps,
  catalog,
  catalogLoaded,
  catalogFailed,
}) => {
  const tracker = useTracker()
  const reported = useRef(false)

  useEffect(() => {
    if (!open) {
      reported.current = false
      return
    }

    if (reported.current || !(catalogLoaded || catalogFailed)) return

    reported.current = true

    tracker.trackEvent(NEW_LAUNCH_STARTED_EVENT[surface], {
      ...trackingProps,
      surface: SURFACE_PROPERTY[surface],
      addon_options_shown: catalogLoaded ? addonOptionsShown(catalog) : null,
    })
    // trackingProps and catalog are rebuilt every render; the open state and
    // the catalog settling are what decide whether to report.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, catalogLoaded, catalogFailed, surface])
}

export default useNewLaunchStarted
